export default __webpack_public_path__ + "static/m-process-04-f474f3dbae4f4f5537eda2f481fc2efd.svg";